export const sections = ['documented', 'employees', 'locations', 'contact']
export const [SECTION_DOCUMENTED, SECTION_EMPLOYEES, SECTION_LOCATIONS, SECTION_CONTACT] = sections
